import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  AUTH_PREFIX_PATH,
  UNAUTHENTICATED_ENTRY,
  REDIRECT_URL_KEY,
} from 'configs/AppConfig';
import store from '../store';
import {
  getFullMerchantData,
  getUser,
  getUserMerchants,
} from '../store/slices/userSlice';

const ProtectedRoute = () => {
  const { token } = useSelector((state) => state.auth);
  const location = useLocation();

  // Only fetch account data once a token exists — firing these unauthenticated
  // produced a storm of identical 401 toasts before the redirect to login.
  useEffect(() => {
    if (!token) return;
    store.dispatch(getFullMerchantData());
    store.dispatch(getUserMerchants());
    store.dispatch(getUser());
  }, [token]);

  if (!token) {
    return (
      <Navigate
        to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${location.pathname}`}
        replace
      />
    );
  }

  return <Outlet />;
};

export default ProtectedRoute;
